import { Translator } from './models/translator';

/**
 * Maps an array of column definitions, translating `tooltip` and optionally
 * `rowColumnTooltip` (when `translateRowTooltip` is `true`) using the provided translator.
 *
 * @param columns - Array of column definitions (may include `translateRowTooltip` flag)
 * @param t - Translator instance (inject `TranslatorService` or use `TRANSLATOR` token)
 * @returns `TableColumn[]` ready to pass to `<cbre-table [columns]>`
 *
 * @example
 * this.columns = translateColumns(COLUMNS, this.translator);
 */
export function translateColumns(columns: Record<string, any>[], t: Translator): Record<string, any>[] {
  return columns.map(({ translateRowTooltip, ...col }) => ({
    ...col,
    ...(col.tooltip ? { tooltip: t.translate(col.tooltip) } : {}),
    ...(translateRowTooltip && typeof col.rowColumnTooltip === 'string'
      ? { rowColumnTooltip: t.translate(col.rowColumnTooltip) }
      : {}),
  }));
}
